import axios from "axios";
import {BASE_URL,login } from "../constants/api-end-pionts";


interface LoginRequestBody {
    phoneOrEmail: string;
    password: string;
}



const loginUser = async (email: string, password: string) => {
    const api = axios.create({
        baseURL: BASE_URL,
        headers: { 
            "Content-Type": "application/json"
        }
    });

    const body: LoginRequestBody = {
        phoneOrEmail: email,
        password: password
    };

    try {
        console.log("API calling. ");
        let response = await api.post(login, JSON.stringify(body));
        return response.data;
    } catch (e) {
        console.log(`error `, e);
    }
};

export default loginUser;